<template>
    <div>
        <b-form>   
            <div class="table-cell">
              <h3>€ {{reportStartDetails.assets}}</h3>
            </div>

            <div class="table-cell">
                <b-form-input 
                    v-model="reportStartDetails.balance_bank_account"
                    size="sm"
                    type="number"
                    class="input-form"/>
            </div>
            <div class="table-cell">
                <b-form-input 
                    v-model="reportStartDetails.cash"
                    size="sm"
                    type="number"
                    class="input-form"/>
            </div>
            <div class="table-cell">
                <b-form-input 
                    v-model="reportStartDetails.accounts_receivable"
                    size="sm"
                    type="number"
                    class="input-form"/>
            </div>
            <div class="table-cell">
                <b-form-input 
                    v-model="reportStartDetails.investments"
                    size="sm"
                    type="number"
                    class="input-form"/>
                <div class="table-cell cell-spacer-single" />
            </div>

            <div class="table-cell cell-spacer-double" />

            <div class="table-cell cell-border-top top-cell-element">
              <h3>€ {{ reportStartDetails.liabilities }}</h3>
            </div>

            <div class="table-cell">
                <b-form-input 
                    v-model="reportStartDetails.unpaid_vat"
                    size="sm"
                    type="number"
                    class="input-form"/>
            </div>
            <div class="table-cell">
                <b-form-input 
                    v-model="reportStartDetails.unpaid_expenses"
                    size="sm"
                    type="number"
                    class="input-form"/>
            </div>
            <div class="table-cell">
                <b-form-input 
                    v-model="reportStartDetails.other_debts"
                    size="sm"
                    type="number"
                    class="input-form"/>
            </div>
            <div class="table-cell cell-spacer-single" />

            <div class="table-cell cell-border-top top-cell-element">
              <h3>€ {{ reportStartDetails.equity }}</h3>
            </div>
        </b-form>
    </div>
</template>

<script>
import FinancialReportingService from "@/store/services/financialreporting.service";
import GekkoButton from "@/components/GekkoButton";

export default {
    name: "StartBox",
    components: {GekkoButton},
    props: {
        reportStart: {
            type: Object,
            default: () => {}
        }
    },
    watch: {
        reportStart(newVal) {
            this.reportStartDetails = newVal;
        }
    },
    data() {
        return {
            reportStartDetails: {}
        }
    },
	created() {
		this.reportStartDetails = this.reportStart;
	},
    methods: {
        saveForm() {
            FinancialReportingService.update(this.reportStartDetails.id, this.reportStartDetails).then((response) => {
				this.reportStartDetails = response.data;
                this.$emit("startYearUpdated", response.data);
            }).catch(() => {
                this.$store.commit('setAlert', {
					title: this.$gettext("Oops!"),
					text: this.$gettext("Error setting the start values."),
					variant: "error",
					duration: 4
				});
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.input-form {
	max-width: 100px;
	height: 26px;
	padding: 0 0.5rem;
	display: inline;
}

.table-cell {
	white-space: nowrap;
	color: $colorUnassigned;
	min-width: 125px;

	font-size: inherit;
	padding: 0 1.5rem;
	text-align: right;

	min-height: 2rem;
	max-height: 2rem;

	h3 { 
		white-space: nowrap;
		margin: 0; 
		margin-bottom: 10px;
		padding: 0; 
		color: $colorTextBase;
		line-height: 24px;
		font-size: 22px;
	}
}

.cell-spacer-single {
	height: 1rem;
}

.cell-spacer-double {
	height: 2rem;
}

.cell-border-top {
	border-top: 1px solid $tableBorderColor;
	min-height: 3rem;
}

.top-cell-element {
	padding-top: 1rem;
}

@media(max-width: '576px') {
    .table-cell {
        padding: 0 0.5rem;
    }
}
</style>